export const ROUTE_PATH = {
  BASE: "",
  ABOUT: "about",
  CONTACT: "contact",
  CART: "cart",
  CHECKOUT: "checkout",
  TERMS: "terms",
  ADMIN: "plus",
  INCENSES: "incenses",
  SPICES: "spices",
  B2B: "b2b",
  MY_ORDER: "myorder",
  PRODUCT_DETAILS: "product/details/",
  WHATSAPP: "https://wa.me/",
  ANDROID_APP: "/app/android/Shikriti.apk",
};

export const SERVER_API = {
  HOME_LOOKUPS: "/Lookups/HomeLookups/",
  CONTACTS: "/Lookups/Contacts/",
  INCENSES: "/Lookups/Incenses/",
  SPICES: "/Lookups/Spices/",
  GET_ORDERS: "/Orders/UserOrders/?phone={0}&pageNo={1}",
  POST_ORDERS: "/Orders/UserOrders/",
};

export const OREDER_STATUS = {
  ORDERED: "ORDERED",
  PAID: "PAID",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  INTRANSIT: "INTRANSIT",
  DELIVERED: "DELIVERED",
  DELETED: "DELETED",
};
